/* import __COLOCATED_TEMPLATE__ from './payout-method-card.hbs'; */
import Component from '@ember/component';

const CLASS_NAME = 'SH-c-payout-method-card';

export default Component.extend({
  classNames: [CLASS_NAME, 'LSG-l-bubble-container', 'only-small-and-down-flat-edges'],
  CLASS_NAME,

  /** @param {PayoutMethod|null} */
  payoutMethod: null,

  /** @param {Function} */
  onMethodSelect: () => {},

  actions: {
    handleMethodSelect() {
      this.get('onMethodSelect')(this.get('payoutMethod'));
    },
  },
});
